import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export const initGA = () => {
  if (process.env.NODE_ENV === 'production' && MEASUREMENT_ID) {
    ReactGA.initialize(MEASUREMENT_ID);
  }
};

export const logPageView = () => {
  if (process.env.NODE_ENV === 'production' && MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
  }
};

export const logEvent = (category: string, action: string, label?: string) => {
  if (process.env.NODE_ENV === 'production' && MEASUREMENT_ID) {
    ReactGA.event({ category, action, label });
  }
};
